export class DeclRendWebModel {

    constructor(
        public aaDecl?: number,
        public cdCentrus?: number,
        public dsCompl1?: string,
        public dsCompl2?: string,
        public dsCompl3?: string,
        public dsCompl4?: string,
        public dsCompl5?: string,
        public dsCompl6?: string,
        public dsLocaliz?: string,
        public dsNatureza?: string,
        public dsNaturezaAcum?: string,
        public dsOutros?: string,
        public dsOutrosExcl?: string,
        public dsTxtSj1?: string,
        public dsTxtSj2?: string,
        public dsTxtSj3?: string,
        public nrCpf?: string,
        public nrProcAcum?: string,
        public qtMesesAcum?: number,
        public vl13Sal?: number,
        public vl65anos?: number,
        public vlAposent?: number,
        public vlCompl1?: number,
        public vlCompl2?: number,
        public vlCompl3?: number,
        public vlCompl4?: number,
        public vlCompl5?: number,
        public vlCompl6?: number,
        public vlContribAcum?: number,
        public vlDespesaAcum?: number,
        public vlDiarias?: number,
        public vlInss?: number,
        public vlIr13?: number,
        public vlIrAcum?: number,
        public vlIrSj?: number,
        public vlIrrf?: number,
        public vlIsentoAcum?: number,
        public vlLucros?: number,
        public vlOutros?: number,
        public vlOutrosExcl?: number,
        public vlPensAlim?: number,
        public vlPensaoAcum?: number,
        public vlPrevPrivada?: number,
        public vlRendAcum?: number,
        public vlRendSj?: number,
        public vlRendimentos?: number,
        public vlRescisao?: number,
        public vlSocioMe?: number,
        public vlIsento13?: number,
        public vlJurosMora?: number
    ) {
    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/models/declRendWeb.model.ts